import React from 'react';
import { Button } from 'reactstrap';
import PropsTypes from 'prop-types';
import classnames from 'classnames';

import useI18n from 'hooks/use-i18n';

const GroupButtonSubmit = (props) => {
  const i18n = useI18n();
  const { className, children, disabled, onCancel } = props;
  return (
    <div className={classnames('flexRow align-items-center', className)}>
      {children}
      <span className="ml-05">{i18n.t('userInfo.or')}</span>
      <Button.Ripple
        color="flat-secondary"
        disabled={disabled}
        onClick={onCancel}
        className="pt-05 pb-05 pl-05 pr-05 ml-05 btn-default-p"
      >
        {i18n.t('userInfo.cancel')}
      </Button.Ripple>
    </div>
  );
};

GroupButtonSubmit.prototype = {
  onCancel: PropsTypes.func.isRequired,
  disabled: PropsTypes.bool,
  className: PropsTypes.any,
};

export default GroupButtonSubmit;
